import { useQuery } from '@hooks/reactQuery';

import { getCommissionHistory } from '@api/commissionSettings';

import { extractQueryParams } from '@utils/common';

import { TCommissionHistory } from '@interfaces/organisation/organisations';

import { refetchOptions } from '@constants/common';
import { COMMISSION_HISTORY } from '@constants/queryKeys';

export const useQueryCommissionHistory = (id?: string) => {
	const {
		data: commissionHistory,
		isLoading,
		isFetching,
	} = useQuery<TCommissionHistory>({
			queryKey: [COMMISSION_HISTORY, id],
			queryFn: extractQueryParams(getCommissionHistory),
			enabled: [!!id],
			...refetchOptions,
		},
	);

	return {
		isLoadingCommissionHistory: isLoading || isFetching,
		commissionHistory: commissionHistory?.items || [],
		countOfRecords: commissionHistory?.count || 0,
	};
};
